module.exports = __webpack_public_path__ + "media/dogs/dachshund-in-box-blue-300-e3d61f58.svg";